import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { locationStatusChip, groupCountry } from '@/util/locationCheck'

type Category = {
  id: number
  name: string
  label_color: string
  description?: string | null
  archived: number
  location_check_mode?: string
  location_radius_m?: number | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryListView',
  props: {
  categories: { type: Array as () => Category[], default: () => [] },
},
  emits: ['add', 'edit'],
  setup(__props, { emit }) {

const props = __props

// Time tracking categories drawer, list view (OTC-2926): one row per active
// category with its location check status. Clicking a row opens the edit view.




const country = groupCountry()

const active = computed(() => (props.categories || [])
  .filter((c) => Number(c.archived) === 0)
  .sort((a, b) => String(a.name).localeCompare(String(b.name))))

function chip(c: Category) {
  return locationStatusChip(c.location_check_mode, c.location_radius_m, country)
}

function hasCheck(c: Category) {
  return c.location_check_mode === 'warning' || c.location_check_mode === 'block'
}


return { __sfc: true,props, emit, country, active, chip, hasCheck }
}

})